






import { defineComponent } from "@vue/composition-api";
import BasePage from "@/components/BasePage";
import SignUpEmailConfirm from "@/components/SignUpEmailConfirm";

export default defineComponent({
  name: "PageEmailConfirm",
  components: { BasePage, SignUpEmailConfirm },
});
